export default defineNuxtPlugin(() => {
  const {
    public: { tolkieConfig },
  } = useRuntimeConfig();
  const tolkie = tolkieConfig?.tolkie;

  if (!tolkie?.enabled) return;

  useHead({
    script: [
      {
        id: 'tolkie-script',
        src: 'https://app.tolkie.nl',
        type: 'module',
        defer: true,
        // data-* need bracket notation to satisfy TS
        ['data-tolkie-token']: tolkie.token,
        ['data-tolkie-wait-init']: true,
        ['data-tolkie-state']: 'separateButtons',
      },
    ],
  });
});
